import { inferenceHttp } from '@/lib/api/http-client';
import {
  ObjectExportAssetDto,
  ObjectExportDto,
  ObjectExportGetStatusDto,
  ObjectExportsService,
} from '@inference.engine/api-client/web';

export type CreateObjectExportRequest = {
  templateKey: string;
  data: Record<string, unknown>;
  additionalOptions?: Record<string, unknown>;
};

export type ObjectExportStatusRequest = {
  controllerId: string;
  templateKey: string;
};

export async function createObjectExport(
  request: CreateObjectExportRequest,
): Promise<ObjectExportDto> {
  const response = await ObjectExportsService.create({
    client: inferenceHttp,
    body: {
      templateKey: request.templateKey,
      data: request.data,
      additionalOptions: request.additionalOptions,
    },
  });

  if (!response.data) {
    throw new Error('Failed to create object export');
  }

  return response.data;
}

export async function getObjectExportStatus(
  request: ObjectExportStatusRequest,
): Promise<ObjectExportGetStatusDto> {
  const response = await ObjectExportsService.getStatus({
    client: inferenceHttp,
    query: {
      controllerId: request.controllerId,
      templateKey: request.templateKey,
    },
  });

  if (!response.data) {
    throw new Error('Failed to get object export status');
  }

  return response.data;
}

export async function getObjectExportAsset(
  request: ObjectExportStatusRequest,
): Promise<ObjectExportAssetDto> {
  const response = await ObjectExportsService.getAsset({
    client: inferenceHttp,
    query: {
      controllerId: request.controllerId,
      templateKey: request.templateKey,
    },
  });

  if (!response.data) {
    throw new Error('Failed to get object export asset');
  }

  return response.data;
}
